import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/app-ui.css';
import './styles/auth-split.css';
import 'katex/dist/katex.min.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
